import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserEsercitazione } from 'src/app/model/esercitazione/useresercitazione';
import { EsercitazioneService } from 'src/app/service/esercitazione.service';
import { first } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-esercitazione-valutazione',
  templateUrl: './esercitazione-valutazione.component.html',
  styleUrls: ['./esercitazione-valutazione.component.css']
})
export class EsercitazioneValutazioneComponent implements OnInit {

    @Input() esercitazione: UserEsercitazione;
    @Input() isTfaSimulator = false;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onNuovaEsercitazioneClick: EventEmitter<void> = new EventEmitter<void>();
    currentQuestion = 0;
    domandaImage: any;

    private readonly imageType: string = 'data:image/JPG;base64,';

    constructor(
        private sanitizer: DomSanitizer,
        private esercitazioneSrv: EsercitazioneService
    ) { }

    ngOnInit() {
        this.getDomandaImageJson();
    }

    nuovaEsercitazione() {
        this.onNuovaEsercitazioneClick.emit();
    }

    prevQuestion() {
        if (this.currentQuestion === 0) {
            this.currentQuestion = this.esercitazione.domande.length - 1;
        } else {
            this.currentQuestion = this.currentQuestion - 1;
        }

        this.getDomandaImageJson();
    }

    nextQuestion() {
        if (this.currentQuestion === this.esercitazione.domande.length - 1) {
            this.currentQuestion = 0;
        } else {
            this.currentQuestion = this.currentQuestion + 1;
        }

        this.getDomandaImageJson();
    }

    getDomandaImageJson() {
        if (this.esercitazione.domande[this.currentQuestion].immagineAssociata == null) {
            this.domandaImage = null;
        } else {
            this.esercitazioneSrv.downloadEsercitazioneDomandaImageJson(
            this.esercitazione.domande[this.currentQuestion].immagineAssociata)
            .pipe(first())
            .subscribe(
                data => {
                    this.domandaImage = this.sanitizer.bypassSecurityTrustUrl(this.imageType + data.result);
                },
                error => {
                    return;
                }
            );
        }
    }

}
